import axios from "axios";
import { getClientConfig } from "@/hooks/useClientConfig";
import { getUserManager } from "../auth/userManagerSingleton";

const DEFAULT_REQUEST_TIMEOUT_MS = 350000

const getBaseUrl = () => {
    const config = getClientConfig()
    return config.data?.roadmapApi;
}

export interface ActionResponse<T> {
    data: T | null
    success: boolean
    errors: ValidationError[];
}

export interface ValidationError {
    error: string
}

export const getApi = () => {
    const api = axios.create({
        baseURL: getBaseUrl(),
        timeout: DEFAULT_REQUEST_TIMEOUT_MS,
    })

    api.interceptors.request.use(async (config) => {
        console.log(`Request ${config.url}`)
        return config
    })

    api.interceptors.response.use(async (response) => {
        console.log(`Response ${response.config.url}: ${response.status}`)
        return response
    })

    return api
}

const getAccessToken = async () => {
    const userManager = getUserManager()
    if (!userManager) {
        return ""
    }

    const user = await userManager.getUser()
    return user?.access_token ?? ""
}

export const getAuthedApi = async () => {
    const authedApi = axios.create({
        baseURL: getBaseUrl(),
        timeout: DEFAULT_REQUEST_TIMEOUT_MS,
    })

    authedApi.interceptors.request.use(async (config) => {
        config.headers.Authorization = "Bearer " + await getAccessToken()
        console.log(`Request ${config.url}`)
        return config
    })

    authedApi.interceptors.response.use(async (response) => {
        console.log(`Response ${response.config.url}: ${response.status}`)
        return response
    })

    return authedApi
}